/**
 * given a string representing a "." path, split it in to pieces
 *
 * @param path
 * @return {{path: any, field: (*|string)}}
 */
export default function pathToParts(path) {
	const parts = path.split('.');
	const partsPath = parts.length > 1 ? parts.slice(0, parts.length - 1).join('.') : undefined;
	return {
		path: partsPath,
		field: parts[parts.length - 1]
	};
};